import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api, trackEvent } from '../api';
import './tgoffer.css';

/** Narx chegarasi: e'lon narxidan +20%, 100 mingga yaxlitlab — «shunga o'xshash» biroz qimmatroqlarini ham qamrab oladi */
export const similarMaxPrice = (uzs) => (uzs > 0 ? Math.ceil((uzs * 1.2) / 100000) * 100000 : null);

/**
 * «Shunga o'xshash yangi e'lonlar chiqsa — Telegram'ga yuboramiz». Ro'yxatdan o'tish shart emas:
 * server filtrlar bilan bir martalik t.me havolasini beradi, obuna botda «Start» bosilganda yaratiladi.
 * filters: { adType: RENT|PARTNER, region, district, maxPrice, rooms }; place: ad | list | home (statistika).
 */
export default function TelegramOffer({ filters, place, text, compact }) {
  const { t, i18n } = useTranslation();
  const [state, setState] = useState('idle'); // idle | busy | opened | error
  const [msg, setMsg] = useState('');

  const open = async () => {
    setState('busy');
    trackEvent('tg_offer_click', `${place}:${filters.adType || 'RENT'}`);
    // Oyna darhol ochiladi (aks holda brauzer await'dan keyingi window.open'ni bloklaydi), havola kelgach yo'naltiriladi
    const win = window.open('', '_blank');
    const r = await api.tgGuest({ ...filters, lang: (i18n.language || 'uz').slice(0, 2), place }).catch(() => null);
    const url = r?.element?.url;
    if (!url) {
      if (win) win.close();
      setMsg(r?.message ? t(r.message) : t("Hozir ulab bo'lmadi. Birozdan keyin urinib ko'ring."));
      setState('error');
      return;
    }
    if (win) win.location.href = url; else window.location.href = url;
    setState('opened');
  };

  return (
    <div className={`tgo${compact ? ' compact' : ''}`}>
      {!compact && <p className='tgo-text'>{text || t("Shunga o'xshash yangi e'lonlar chiqishi bilan Telegram'ga yuboramiz. Ro'yxatdan o'tish shart emas.")}</p>}
      <button type='button' className='tgo-btn' onClick={open} disabled={state === 'busy'}>
        <svg viewBox='0 0 24 24' width='18' height='18' aria-hidden='true'><path fill='currentColor' d='M21.9 4.6 18.7 19.4c-.2 1-.9 1.3-1.8.8l-4.9-3.6-2.4 2.3c-.3.3-.5.5-1 .5l.3-5 9.1-8.2c.4-.4-.1-.6-.6-.2L6.2 13 1.4 11.5c-1-.3-1-1 .2-1.5L20.6 2.7c.9-.3 1.6.2 1.3 1.9z' /></svg>
        {state === 'busy' ? t('Ochilmoqda...') : t("Telegram'da xabar olish")}
      </button>
      {state === 'opened' && <p className='tgo-note'>{t("Telegram ochildi — botda «Start» tugmasini bosing.")}</p>}
      {state === 'error' && <p className='tgo-note err'>{msg}</p>}
      {!compact && (
        <a className='tgo-chan' href='https://t.me/MyIjarachiUz' target='_blank' rel='noopener noreferrer' onClick={() => trackEvent('channel_click', place)}>
          {t("Yoki yangi e'lonlar kanalida: @MyIjarachiUz")}
        </a>
      )}
    </div>
  );
}
